export default function (text: string, limit = 500) {
  if (text.length > limit) {
    return text.slice(0, limit);
  }
  return text;
}
